module.exports = __webpack_public_path__ + "static/media/Daycare Preschool.98915fda.jpg";